import type { Observable } from 'rxjs';
import type { AddressBook } from '@integrations/address-books/contracts/address-book.contract';

import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { parseResponse } from '@integrations/shared/parse-response';
import { AddressBookCollectionResponseSchema } from '@integrations/address-books/contracts/address-book.contract';

export const EMAIL_SERVICE_API_BASE = new InjectionToken<string>('EMAIL_SERVICE_API_BASE', {
    providedIn: 'root',
    factory: () => '/api/email-service',
});

@Injectable({ providedIn: 'root' })
export class AddressBooksApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(EMAIL_SERVICE_API_BASE);

    public getActiveAddressBooks(): Observable<AddressBook[]> {
        return this.http.get<unknown>(`${this.baseUrl}/address-books/active`).pipe(
            map(
                (res) =>
                    parseResponse(res, AddressBookCollectionResponseSchema, {
                        endpoint: 'address-books/active',
                        method: 'GET',
                    }).data
            )
        );
    }
}
